<span (click)="snackBar.dismissWithAction()">Contact is not verified. Tap to verify security.</span>
